// This has emptied out results i.e. is static
const STATIC_BALLOT_PAGE =
  'https://s3.amazonaws.com/sos-test-2.texastribune.org/2020_general/ballot_page/results_FLAT_for_ballot.json';

// What we are using across the ap
// will be used on the results page, in the homepage takeover
// and in the embeds
const RESULTS_IN_USE = STATIC_BALLOT_PAGE;

// The number of candidates visible for each race. Usually it's 3 but I decided to turn it off so I made it a crazy high number
const visibleCandidateCount = 53

export { RESULTS_IN_USE, visibleCandidateCount };
